import { render, staticRenderFns } from "./MaxHeartPerStageConfigForm.vue?vue&type=template&id=2544ea4b&scoped=true&"
import script from "./MaxHeartPerStageConfigForm.vue?vue&type=script&lang=js&"
export * from "./MaxHeartPerStageConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./MaxHeartPerStageConfigForm.vue?vue&type=style&index=0&id=2544ea4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544ea4b",
  null
  
)

export default component.exports